module.exports = __webpack_public_path__ + "static/media/miCapital.f20c5b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/miCapital.png
// module id = 103
// module chunks = 0